var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.cc)?_c('img',{staticClass:"famfamfam-flags",class:_vm.countryCode,attrs:{"src":require("../assets/pixel.png"),"alt":_vm.countryCode + ' flag'}}):_c('span',{staticClass:"empty-flag"})])
}
var staticRenderFns = []

export { render, staticRenderFns }